<template>
  <div class="animated fadeIn">
    <b-card no-body>
      <b-card-header>
        <i class="fa fa-list mr-2"></i><strong>Liste des consignes</strong>
        <span class="pull-right"><i>Dernière màj effectuée le {{ formatDateHelper(dateMaj) }}</i></span>
      </b-card-header>
      <b-card-body>
        <v-client-table :columns="columns" :data="data" :options="options">
          <div v-if="props.row.created_at" slot="created_at" slot-scope="props" class="slot-date">
            <span class="badge badge-success p-2">{{ formatDateHeure(props.row.created_at) }}</span>
          </div>
          <div v-if="props.row.date_modification" slot="date_modification" slot-scope="props" class="slot-date">
            <span class="badge badge-success p-2">{{ formatDateHeure(props.row.date_modification) }}</span>
          </div>
          <div slot="action" slot-scope="props">
            <i class="fa fa-pencil mr-2 text-primary clickable" @click="edit(props.row.id)"></i>
            <i class="fa fa-trash clickable text-danger" @click.prevent="destroy(props.row.id)"></i>
          </div>
        </v-client-table>
      </b-card-body>

      <div slot="footer">
        <b-button v-if="canExtract(rules.EXTRACT_CONSIGNES_BLOCAGES)" type="button" size="md" variant="success">
          <i class="fa fa-file-excel-o"></i>&nbsp;<a @click="downloadConsignesBlocage" class="bleu_clair">Exporter en Excel</a><br>
        </b-button>
        <b-button type="button" @click="add" class="pull-right" size="md" variant="primary">
          <i class="fa fa-plus"></i> Ajouter une consigne
        </b-button>
      </div>
    </b-card>
  </div>
</template>

<script>
  import {getAccessToken, getBaseUrl, getIdToken, getProvider} from "../../../../utils/auth";
  import { isEmpty, downloadFile } from "@/utils/fileHelper";
  import { espaceGestionRules, hasRule} from "@/utils/rulesHelper";
  import { formatDate } from "@/utils/communHelper";

  export default {
    name: "List",
    data() {
      return {
        columns: ['created_at', 'code_blocage', 'libelle_blocage', 'aide', 'date_modification', 'action'],
        data: [],
        options: {
          headings: {
            'created_at': 'Date de création',
            'libelle_blocage': 'Libellé blocage',
            
            'code_blocage': 'Code blocage',
            'aide': 'Aide',
            'date_modification': 'Date de modif.',
          },
          columnsClasses: {
            code_blocage: 'pre-formatted sort-top position-r col-xs',
            libelle_blocage: 'pre-formatted sort-top position-r libelle-blocage-col-xs',
            aide: 'pre-formatted sort-top position-r',
            created_at : 'pre-formatted sort-top position-r col-xs',
            date_modification : 'col-xs',
            action: 'pre-formatted sort-top position-r action-xs',
          },
          sortable: ['created_at', 'libelle_blocage', 'code_blocage', 'date_modification'],
          filterable: ['libelle_blocage', 'code_blocage'],
          perPage: 10,
          perPageValues: [10, 25, 50],
          texts: {
            filterPlaceholder: "Libellé ou Code blocage"
          },
          orderBy: {column: 'code_blocage', ascending: false},
        },
        rules: espaceGestionRules
      }
    },
    mounted() {
      this.all();
    },
    created() {
      this.$axios.defaults.baseURL = getBaseUrl();
      this.$axios.defaults.headers.common["Authorization"] = getIdToken() + " " + getAccessToken();
      this.$axios.defaults.headers.common["Accept"] = "application/json";
      this.$axios.defaults.headers.common["Provider"] = getProvider();
    },
    computed:{
      dateMaj(){
        if (this.data.length == 0) return 
          let lastEditedAt = this.data.reduce((a,b) => Number(a.updated_at) > Number(b.updated_at) ? a : b);
        return lastEditedAt.updated_at;
      }
    },
    methods: {
      all() {
        this.$axios
          .get("/espaceGestion/consignes-blocages")
          .then(response => {
            this.data = response.data.data;
          })
          .catch(() => {
            this.$store.commit("IS_LOADING", false);
            this.handleError();
          });
      },
      destroy(id) {
        let self = this;
        this.$swal
          .fire({
            title: 'Êtes-vous sûr?',
            text: "Voulez-vous vraiment supprimer cette consigne ?",
            type: 'warning',
            reverseButtons: true,
            showCancelButton: true,
            cancelButtonColor: "#ff1744",
            confirmButtonText: 'Annuler',
            cancelButtonText: 'Supprimer',
          })
          .then((result) => {
            if (!result.value) {
              this.$store.commit('IS_LOADING', true)
              this.$axios
                .delete("/espaceGestion/consignes-blocages/" + id)
                .then(() => {
                  this.$store.commit('IS_LOADING', false)
                  this.$swal({
                    position: 'top',
                    type: 'success',
                    title: 'Suppression avec succès',
                    text: "La consigne a bien été supprimée",
                    showConfirmButton: false,
                    timer: 5000
                  });
                  this.all();
                })
                .catch(() => {
                  self.$store.commit("IS_LOADING", false);
                  self.handleError();
                })
            }
          })

      },
      add() {
        this.$router.push({path: '/espace-gestion/consignes-blocage/add'})
      },
      edit(id) {
        this.$router.push({path: '/espace-gestion/consignes-blocage/edit/' + id})
      },
      handleError() {
        this.$swal({
          position: 'top',
          type: 'error',
          title: 'Attention !!',
          text: 'Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI',
          showConfirmButton: false,
          timer: 5000
        });
      },
      formatDateHeure(textDate) {
        let date = textDate !== null ? new Date(textDate).toLocaleString("fr-FR") : "-";
        return date;
      },
      formatDateHelper(textDate) {
        return formatDate(textDate);
      },
      canExtract(rule) {
        return hasRule(rule)
      },
      downloadConsignesBlocage() {
        let url = 'extract_consignes_blocages'
        let filename = 'consignes_blocages'
        let extension = 'csv'
        let self = this
        extension = isEmpty(extension) ? 'csv' : extension;

        this.$store.commit('IS_LOADING', true);
        this.$axios.get(`/espaceGestion/extractions/${url}`, {responseType: 'blob'})
          .then((response) => {
            this.$store.commit('IS_LOADING', false);
            downloadFile(response, filename, extension);
          })
          .catch(error => {
            self.$store.commit('IS_LOADING', false);
            let errorText = "Une erreur est survenue. Si le problème persiste, merci de faire un ticket au support DOSI."
            if (error.response.status === 403) {
              errorText = "Vous n'êtes pas autorisé à effectuer cette action"
            }
            self.$swal({
              position: "top",
              type: "error",
              title: "Attention !!",
              text: errorText,
              showConfirmButton: false,
              timer: 5000
            })
          });
      },
    }
  }
</script>
